import { markInvalidFields } from "../services/ValidationService";

/**
 * Telefonnummer als Pflichtfeld bei bestimmten Versandarten.
 *
 * Bei Abholung im Versandlager und bei Express braucht das Lager eine
 * Rueckrufnummer. Die Rechnungsadresse muss die Nummer bei beiden Versandarten
 * tragen. Eine abweichende Lieferadresse nur bei Express - bei Abholung wird
 * nicht an sie geliefert.
 *
 * Gleiche Preset-IDs wie in views/Checkout/ShippingProfileSelect.twig.
 */
export const SHIPPING_PROFILE_EXPRESS = 29;
export const SHIPPING_PROFILE_ABHOLUNG = 42;

const PHONE_OPTION_TYPE_ID = 4;

/**
 * @param {number} shippingProfileId
 * @param {string} addressType "1" = Rechnungsadresse, "2" = Lieferadresse
 * @returns {boolean}
 */
export function isPhoneRequired(shippingProfileId, addressType)
{
    const profileId = Number(shippingProfileId);

    if (String(addressType) === "2")
    {
        return profileId === SHIPPING_PROFILE_EXPRESS;
    }

    return profileId === SHIPPING_PROFILE_EXPRESS || profileId === SHIPPING_PROFILE_ABHOLUNG;
}

/**
 * Prueft die Telefonnummer einer Adresse aus dem Store.
 *
 * Nach dem Bearbeiten im Modal schreibt der Store die Formulardaten zurueck
 * (AddressModule.updateBillingAddress). Die Nummer steht dann in "telephone",
 * eine bisher fehlende Telefon-Option legt _syncOptionTypesAddressData aber
 * nicht an. "telephone" hat deshalb Vorrang vor options.
 * @param {object} address
 * @returns {boolean}
 */
export function hasPhoneNumber(address)
{
    if (typeof address?.telephone === "string")
    {
        return address.telephone.trim().length > 0;
    }

    return !!address?.options?.some(option => option.typeId === PHONE_OPTION_TYPE_ID && String(option.value || "").trim().length > 0);
}

/**
 * Leeres Pflicht-Telefonfeld im Adress-Modal direkt rot markieren.
 * Nur wenn das Feld per v-validate Pflicht ist (data-validate) - beim Oeffnen
 * fuer das Geburtsdatum (Rechnungskauf) bleibt es so unmarkiert, solange keine
 * Versandart die Nummer verlangt. Die Markierung verschwindet bei Eingabe
 * (markInvalidFields bindet die Listener dafuer).
 * @param {HTMLElement} container
 */
export function markMissingPhoneField(container)
{
    const fields = $(container).find(".input-unit[data-model='telephone'][data-validate]")
        .filter((index, elem) => !String($(elem).find("input").val() || "").trim());

    markInvalidFields(fields);
}
